// 首页地址
export const HOME_URL: string = '/'
// token
export const TOKEN_KEY: string = 'mespery-novel-web-token'
